module.exports = __webpack_public_path__ + "img/elements-logo.019e3f11.svg";